(() => {
  document.documentElement.classList.add('hx-anim');
  const initSliders = root => root.querySelectorAll('[data-hx-slider]').forEach(el => {
    if (el.dataset.ready) return; el.dataset.ready = '1';
    const track = el.querySelector('[data-hx-track]');
    const prev = el.querySelector('[data-hx-prev]');
    const next = el.querySelector('[data-hx-next]');
    const dots = [...el.querySelectorAll('[data-hx-dot]')];
    const count = track.children.length;
    const index = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    const go = i => track.scrollTo({ left: Math.max(0, Math.min(count - 1, i)) * track.clientWidth });
    const update = () => { const i = index(); if (prev) prev.disabled = i <= 0; if (next) next.disabled = i >= count - 1; dots.forEach((d, n) => d.setAttribute('aria-current', String(n === i))); };
    prev && prev.addEventListener('click', () => go(index() - 1));
    next && next.addEventListener('click', () => go(index() + 1));
    dots.forEach((d, n) => d.addEventListener('click', () => go(n)));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    track.addEventListener('keydown', e => { if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); } });
    update();
  });
  const initRows = root => root.querySelectorAll('[data-hx-row]').forEach(row => {
    if (row.dataset.ready) return; row.dataset.ready = '1';
    const motion = row.querySelector('[data-hx-motion]');
    const btn = row.querySelector('[data-hx-play]');
    const link = row.querySelector('[data-hx-play-link]');
    if (motion && btn) {
      const img = motion.querySelector('img');
      const label = btn.querySelector('[data-hx-play-label]');
      const set = on => {
        if (on && !img.src) img.src = img.dataset.src;
        motion.hidden = !on;
        btn.setAttribute('aria-pressed', String(on));
        label.textContent = on ? label.dataset.stop : label.dataset.play;
      };
      btn.addEventListener('click', () => set(motion.hidden));
      link && link.addEventListener('click', () => { set(true); if (matchMedia('(max-width: 800px)').matches) row.querySelector('.hx-row__media').scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      motion.addEventListener('click', () => set(false));
    }
  });
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }) : null;
  const reveal = root => root.querySelectorAll('.hx-row:not(.is-in)').forEach(r => io ? io.observe(r) : r.classList.add('is-in'));
  const run = root => { initSliders(root); initRows(root); reveal(root); };
  run(document);
  document.addEventListener('shopify:section:load', e => run(e.target));
})();

